// extracted by mini-css-extract-plugin
export default {"formWrapper":"text-template-details_formWrapper__D-8uM","fieldsWrapper":"text-template-details_fieldsWrapper__ENZFq","inputField":"text-template-details_inputField__Zp-fJ"};